import { Navbar, Nav, Container } from 'react-bootstrap';
import { Box, Grid} from '@mui/material';
import {useTheme, useMediaQuery } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/UserContext';
import LoadingScreen from './LoadingScreen'; // Import the LoadingScreen component
import logo from '../assests/images/logo.png';
import bg from '../assests/images/bg.jpg';

export default function Navgationbar() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { setUserInfo, userInfo } = useContext(UserContext);
  const location = useLocation(); // Capture current location

  const [isLoading, setIsLoading] = useState(false);

  // Function to fetch user profile
  const fetchUserProfile = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/profile`, {
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        setUserInfo(data);
      } else {
        setUserInfo(null); // If unauthorized, reset userInfo
      }
    } catch (error) {
      console.error('Failed to fetch profile:', error);
      setUserInfo(null);
    }
  };

  // Fetch profile when component mounts
  useEffect(() => {
    fetchUserProfile(); // Fetch user profile on component mount
  }, []);

  // Update the loading state when the location (route) changes
 

  // Logout function
  const logout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/logout`, {
        credentials: 'include',
        method: 'POST',
      });
      if (response.ok) {
        setUserInfo(null); // Clear user info on successful logout
        await fetchUserProfile(); // Re-fetch profile to ensure no unauthorized access
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const username = userInfo?.username;


  return (
    <>
      {isLoading ? ( 
        // Display LoadingScreen if navigating
        <LoadingScreen />
      ) : (
        <Navbar expand="lg" className="navbar border" style={{ position: 'relative', zIndex: 2,  padding: !isSmUp ? '0 2rem' : '0px 0px'}}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${bg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              zIndex: -1,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: '#fceade',
              opacity: 0.8,
              zIndex: 2,
            }}
          />

<Container className="d-flex justify-content-between align-items-center" style={{ position: 'relative', zIndex: 2 }}>
  {/* Left-aligned logo */}
  <Navbar.Brand as={Link} to="/" className="site-logo fw-bold">
    <img src={logo} alt="Logo" style={{ width: '100px' }} />
  </Navbar.Brand>

  {/* Right-aligned hamburger menu */}
  <div className="d-flex">
    <Navbar.Toggle aria-controls="navbarScroll" className="ms-auto" />
  </div>

  {/* Collapsed navbar */}
  <Navbar.Collapse id="navbarScroll">
    <Nav navbarScroll className="ms-auto my-2 my-lg-0">
      <Nav.Link as={Link} to="/">Home</Nav.Link>
      <Nav.Link as={Link} to="/about">About</Nav.Link>
      <Nav.Link as={Link} to="/services">Services</Nav.Link>
      <Nav.Link as={Link} to="/blog">Blog</Nav.Link>
      <Nav.Link as={Link} to="/contact">Contact</Nav.Link>

      {userInfo?.role === 'admin' && (
        <Nav.Link as={Link} to="/blog/create-post">Create new post</Nav.Link>
      )}

      {username ? (
        <>
        <Nav.Link as={Link} to="/profile" >Profile</Nav.Link>
        <Nav.Link onClick={logout}>Logout ({username})</Nav.Link>
        </>
      ) : (
        <Nav.Link as={Link} to="/login" state={{ from: location }}>Login</Nav.Link>
      )}
    </Nav>
  </Navbar.Collapse>
</Container>


        </Navbar>
      )}
    </>
  );
}
